import { ValidatorTypes } from "src/util/validators";

export const projectListPasswordField = {
    password: {
        name: 'password',
        label: 'Password',
        type: 'password',
        touched: false,
        error: false,
        valid: true,
        value: '',
        validation: [ValidatorTypes.REQUIRED, ValidatorTypes.PROJECT_TYPE_PASSWORD]
    },
}